import React from 'react';
import isEmpty from 'lodash/isEmpty';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters,
  FetchProductsSort
} from '../../../../../../products/productsTypes';

import { useThreeDStockProductsSearch } from '../../../../../pages/ThreeDStockProducts/hooks/useThreeDStockProductsSearch';

import {
  FileAttachmentItemImageVersions,
  ImageHelper
} from '../../../../../../../helpers/ImageHelper';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { words } from '../../../../../../../locales/keys';

interface ThreeDStockProductsFiltersImageFilterBadgeProps {
  productsFilters: FetchProductsFilters;
  changeProductsFilters: ChangeProductsFiltersFunc;
  sortProducts?: (nextSort: FetchProductsSort) => void;
}

function ThreeDStockProductsFiltersImageFilterBadge({
  productsFilters,
  changeProductsFilters,
  sortProducts
}: ThreeDStockProductsFiltersImageFilterBadgeProps) {
  const fileAttachmentFile = productsFilters?.similarImage?.imageUrl || '';

  const { onClearSearchSimilarImage } = useThreeDStockProductsSearch({
    changeProductsFilters,
    sortProducts,
    isLibrary: !isEmpty(productsFilters.clientIds)
  });

  if (!fileAttachmentFile) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="relative">
        <ImageHelper
          className="w-full h-auto rounded-lg shadow-sm"
          src={fileAttachmentFile}
          alt="imageSearch"
          version={FileAttachmentItemImageVersions.MiniThumb640x640}
          tooltipAlt
          tooltipAltInteractive
          tooltipAltAppendToBody
        />

        <div className="absolute bottom-0 right-0 p-2">
          <PureButtonHelper
            dataGa="clear-search-similar-image-button"
            className="py-1 pl-2 pr-2 rounded-full inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base text-gray-900 bg-white hover:bg-gray-100 shadow-sm hover:shadow-md transition-colors duration-150 ease-out"
            onClick={onClearSearchSimilarImage}
            i18nText={words.clear}
          />
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockProductsFiltersImageFilterBadge;
